import Balancer from 'react-wrap-balancer';
import {
  Box,
  Flex,
  Show,
  Text,
  Stack,
  type StackProps,
} from '@chakra-ui/react';

import type { JSX } from 'react';

import { QuoteIcon } from '../Icon';

interface IQuoteProps extends StackProps {
  data: {
    content: string;
    author?: string;
    source?: string;
  };
}

export function Quote({ data, ...rest }: IQuoteProps): JSX.Element {
  const { content, author, source } = data;

  return (
    <Stack
      p={6}
      gap={4}
      w='100%'
      maxW='500px'
      boxShadow='lg'
      borderRadius='xl'
      bgColor='gray.900'
      borderTop='5px solid'
      borderBottom='5px solid'
      borderTopColor='gray.700'
      borderBottomColor='gray.700'
      {...rest}
    >
      <Flex pos='relative' alignItems='center' justifyContent='center'>
        <Text
          bgClip='text'
          as={Balancer}
          fontSize='2xl'
          textAlign='center'
          bgImage='-webkit-linear-gradient(0deg, #7fb49e 17%, #31c921 47%, #4ab6c2 100%)'
        >
          <QuoteIcon fill='white' mt='-15px' w='20px' h='20px' />
          {content}
          <QuoteIcon
            w='20px'
            h='20px'
            mt='-15px'
            fill='white'
            transform='rotate(180deg)'
          />
        </Text>
      </Flex>
      <Show when={!!author || !!source}>
        <Box>
          <Show when={!!author}>
            <Text textAlign='center'>{author}</Text>
          </Show>
          <Show when={!!source}>
            <Text textAlign='center'>{source}</Text>
          </Show>
        </Box>
      </Show>
    </Stack>
  );
}
